export const optionsClient = [
    {
        value: 'courier_control',
        label: 'Текст 1',
    },
    {
        value: 'delivery_control',
        label: 'Текст 2',
    },
    {
        value: 'some_control',
        label: 'Текст 3',
    },
];

export const optionsScenario = [
    {
        value: 'sc_1',
        label: 'SC1. Доставка',
    },
    {
        value: 'sc_2',
        label: 'SC2. Оплата',
    },
    {
        value: 'sc_3',
        label: 'SC3. Ефективніть',
    },
];
